import React from 'react';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	title: string;
}

const DENTToothQuickAdjustmentModalTitle = ({ title }: Props) => {
	const { t } = useTranslation();

	return <h2>{t(title)}</h2>;
};

export default DENTToothQuickAdjustmentModalTitle;
